var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-image-view",class:{ __blurred: !_vm.isPublic }},[_c('base-icon',{attrs:{"color":"var(--palette-gray)","font-size":24}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }